import type { MutationHookOptions } from "@apollo/client"
import { useMutation } from "@apollo/client"
import mutation from "@/v2-backoffice-client/uptime/configHostSuffix/delete/uptime.configHostSuffix.delete.mutation.gql"
import { UPTIME_CONFIG_REFETCH_QUERIES } from "@/v2-backoffice-client/uptime/config/uptime.config.query"
import type {
  UptimeConfigHostSuffixDeleteMutation,
  UptimeConfigHostSuffixDeleteMutationVariables,
} from "@/v2-backoffice-client/uptime/configHostSuffix/delete/__types__/uptime.configHostSuffix.delete.mutation"

type Options = MutationHookOptions<
  UptimeConfigHostSuffixDeleteMutation,
  UptimeConfigHostSuffixDeleteMutationVariables
>

export function useUptimeConfigHostSuffixDeleteMutation(options?: Options) {
  return useMutation<
    UptimeConfigHostSuffixDeleteMutation,
    UptimeConfigHostSuffixDeleteMutationVariables
  >(mutation, {
    refetchQueries: [...UPTIME_CONFIG_REFETCH_QUERIES],
    awaitRefetchQueries: true,
    ...options,
  })
}
